module.exports = __webpack_public_path__ + "img/onerror-user.67950dd2.png";